export default axios => ({
  feedback: x => axios.post('contact/feedback', x).then(r => r.data || {})
})
